import { ReactNode } from 'react';
import { FiUser, FiFileText, FiDatabase, FiCalendar } from 'react-icons/fi';
import { PATHS } from './paths';

export const isActive = (href: string) => {
  return window.location.pathname === href || window.location.pathname.includes(href);
};
type MenuType = {
  title: string;
  icon: ReactNode;
  subMenu?: { title: string; href: string }[];
  href?: string;
};

export const SidebarMenu: MenuType[] = [
  { title: 'USER MANAGEMENT', icon: <FiUser />, href: PATHS.ManageUsers },
  {
    title: 'DEPOSITION MANAGEMENT',
    icon: <FiFileText />,
    href: PATHS.DepositionManagement,
  },
  {
    title: 'REPOSITORY',
    icon: <FiDatabase />,
    href: PATHS.RepositoryManagement,
  },
  {
    title: 'SCHEDULE REQUESTS',
    icon: <FiCalendar />,
    href: PATHS.SchedulingRequests,
  },
];
